import darkLogo from "./darkLogo.png";
import lightLogo from "./lightLogo.png";
import orangeLogo from "./orangeLogo.png";
import logoWithoutText from "./logoWithoutText.png";

export const allLogos = {
    darkLogo,
    lightLogo,
    orangeLogo,
    logoWithoutText,
};
